import { parseEnv } from './envSchema';

/**
 * The only file permitted to read `import.meta.env`. Everything else imports `env`.
 *
 * The same schema also runs at build time from `vite.config.ts`, so a misconfigured deployment
 * fails in CI rather than on a player's phone. This runtime parse stays because the build-time
 * check cannot see variables injected by the host at serve time.
 */
export const env = parseEnv(import.meta.env);

export type { AppConfig, AppEnv } from './envSchema';
